import api from '@api'

export function getLeaveTypeApi(archived = false) {
  return api
    .post(
      `/leavetype/search/byqual`,
      {},
      {
        params: {
          ...(archived ? { archived: true } : {}),
          offset: 0,
          size: 1000,
        },
        notify: false,
      }
    )
    .then((data) => {
      return (data.objectList || []).map((c) => ({
        key: c.id,
        id: c.id,
        value: c.id,
        text: c.name,
        label: c.name,
        archived: c.removed,
        color: c.colourCode,
        disabled: c.disabled,
      }))
    })
}
